// extracted by mini-css-extract-plugin
export default {"header":"header_header__jw-Db","header-container":"header_header-container__R5m6z","logo":"header_logo__ZXv3b","logo-name":"header_logo-name__tDccF"};